<template>
<v-card class="ma-2" hover>

    <v-img :src="item.url" height="250px">

        <template v-slot:placeholder>
            <v-progress-linear class="pa-0 ma-0" height="4" indeterminate color="primary" />
        </template>

        <div class="pa-1" style="position: absolute; top:0; left: 0; ">
            <v-chip v-if="item.status==='rejected'" small disabled label style="background-color: red; color: white;opacity:1">Rejected</v-chip>
            <v-chip v-if="item.status==='pending'" small disabled label style="background-color: yellow; color: black;opacity:1">Pending</v-chip>
        </div>

        <div style="position: absolute; bottom:0; left: 0; right: 0; background-color: rgba(255,255,255,.8)">
            <div>
                <div class="pt-1">
                    <div class="text-truncate body-1 mx-2"><small>Photo: </small>{{ item.title}}</div>
                    <div class="text-truncate body-1 mx-2"><small>Place: </small>{{ placeName }}</div>
                    <div class="text-truncate body-1 mx-2"><small>Section: </small> {{ sectionName }}</div>
                </div>
                <div class="pa-1">
                    <v-tooltip top>
                        <template v-slot:activator="{ on }">
                            <span class="ma-1" v-on="on">
                                <v-chip label small disabled color="white">
                                    <v-icon left small>forum</v-icon>
                                    <div style="color: black">{{ item.comment_sum }}</div>
                                </v-chip>
                            </span>
                        </template>
                        <span>Comments</span>
                    </v-tooltip>
                    <v-tooltip top>
                        <template v-slot:activator="{ on }">
                            <span class="ma-1" v-on="on">
                                <v-chip label small disabled color="white">
                                    <v-icon left small>star</v-icon>
                                    <div style="color: black">{{ item.rating_avg }}</div>
                                </v-chip>
                            </span>
                        </template>
                        <span>Rating</span>
                    </v-tooltip>
                    <v-tooltip top>
                        <template v-slot:activator="{ on }">
                            <span class="ma-1" v-on="on">
                                <v-chip label small disabled color="white">
                                    <v-icon left small>priority_high</v-icon>
                                    <div style="color: black">{{ item.order }}</div>
                                </v-chip>
                            </span>
                        </template>
                        <span>Order</span>
                    </v-tooltip>
                </div>
            </div>
        </div>
    </v-img>
</v-card>
</template>

<script>
import defaults from "../utils/PropDefaults.js";

export default {
    props: {
        item: {
            type: Object,
            default: defaults.photo_item
        },
    },

    computed: {
        placeName() {
            return this.item?.place?.name;
        },
        sectionName() {
            return this.item?.section?.name;
        }
    },

    methods: {
        emitClick() {
            this.$emit('click');
        },
    }

}
</script>
